import { _ as i, a as v, b as u } from "../../tslib.es6-CH0JWuEm.mjs";
import { createAvroEventsHub as s } from "@zapier/avro-events";
import { emit as c } from "@zapier/events-toolkit-browser";
import { UserInteractionEvent as _ } from "./trackingTypes.es.js";
import { FullStoryAPI as f } from "@zapier/react-fullstory";
var a = "templates", I = function(t, r, e) {
  return o(t)(i({ system_name: e || a }, r || {}));
}, S = function(t, r) {
  var e = i(i({}, r), { interaction_name: t });
  return o(_)(e);
};
function o(t) {
  var r = s();
  return r.emitFunction = c, function(m) {
    return v(this, void 0, void 0, function() {
      var n;
      return u(this, function(E) {
        return n = i({ system_name: a }, m), f(
          "event",
          // @ts-expect-error // interaction_name might not exist on data
          n.interaction_name || t,
          n
        ), r.emit(n, t), [
          2
          /*return*/
        ];
      });
    });
  };
}
export {
  I as emitEvent,
  S as emitUserInteractionEvent
};
//# sourceMappingURL=emitEvent.es.js.map
